import { render } from "./CartRecapCustomPayments.vue?vue&type=template&id=0b1ba722"
import script from "./CartRecapCustomPayments.vue?vue&type=script&lang=js"
export * from "./CartRecapCustomPayments.vue?vue&type=script&lang=js"

import "./CartRecapCustomPayments.vue?vue&type=style&index=0&id=0b1ba722&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__